import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import { getFbTrackingPayload } from "../../../utils/fbTracking";
import * as actions from "./actions";

function* fetchAvailability() {
  try {
    const result = yield call(AxiosCall, `/numerology/get_availability/`);
    yield put(actions.numerologyAvailabilitySuccess(result.data.available));
  } catch (e) {
    yield put(actions.numerologyAvailabilityError(e));
  }
}

function* calculate(action) {
  try {
    const result = yield call(AxiosPost, `/numerology/calculate/`, action.payload);
    const reading = result.data;
    if (reading.response === "NUMEROLOGY_READING_CONSUMED") {
      throw new Error("Ya realizaste tu consulta diaria de Numerología");
    }
    if (!reading.id) {
      throw new Error("Error al calcular la lectura");
    }
    yield put(actions.numerologyCalculateSuccess(reading));
  } catch (e) {
    yield put(actions.numerologyCalculateError(e));
  }
}

function* fetchPremiumReading(action) {
  try {
    const { reading_id, email } = action.payload;
    const params = new URLSearchParams({ reading_id });
    if (email) params.append('email', email);
    const result = yield call(AxiosCall, `/numerology/get_premium_reading/?${params.toString()}`);
    if (result.data?.response === 'PENDING_REVIEW') {
      yield put(actions.numerologyPremiumPending(result.data.eta_at));
    } else {
      yield put(actions.numerologyPremiumSuccess(result.data));
    }
  } catch (e) {
    yield put(actions.numerologyPremiumError(e));
  }
}

function* createPendingNumerology(action) {
  try {
    const result = yield call(AxiosPost, `/numerology/create_pending_reading/`, action.payload);
    yield put(actions.createPendingNumerologySuccess(
      result.data.reading_id,
      result.data.full_name,
    ));
  } catch (e) {
    yield put(actions.createPendingNumerologyFailure(e));
  }
}

function* createConsultaNumerology(action) {
  try {
    const result = yield call(AxiosPost, `/numerology/create_consulta_reading/`, action.payload);
    yield put(actions.createPendingNumerologySuccess(
      result.data.reading_id,
      result.data.full_name,
    ));
  } catch (e) {
    yield put(actions.createPendingNumerologyFailure(e));
  }
}

function* createBodaNumerology(action) {
  try {
    // calculate_boda crea la lectura kind=boda (2 novios + fecha + lugar) y
    // devuelve `id`. El create_checkout luego elige el descriptor de boda por
    // el kind de la lectura, así que no hace falta endpoint aparte.
    const result = yield call(AxiosPost, `/numerology/calculate_boda/`, action.payload);
    yield put(actions.createPendingNumerologySuccess(
      result.data.id,
      result.data.person_a?.name || '',
    ));
  } catch (e) {
    yield put(actions.createPendingNumerologyFailure(e));
  }
}

function* createCheckout(action) {
  try {
    const result = yield call(AxiosPost, `/numerology/create_checkout/`, { ...action.payload, ...getFbTrackingPayload() });
    const { checkout_url } = result.data;
    yield put(actions.numerologyCheckoutSuccess(checkout_url));
    window.location.href = checkout_url;
  } catch (e) {
    yield put(actions.numerologyCheckoutFailure(e));
  }
}

function* createPaypalOrder(action) {
  try {
    const result = yield call(AxiosPost, `/numerology/create_paypal_order/`, { ...action.payload, ...getFbTrackingPayload() });
    const { approve_url } = result.data;
    yield put(actions.numerologyPaypalOrderSuccess(approve_url));
    window.location.href = approve_url;
  } catch (e) {
    yield put(actions.numerologyPaypalOrderFailure(e));
  }
}

function* verifyPurchase(action) {
  try {
    const result = yield call(AxiosPost, `/numerology/verify_purchase/`, action.payload);
    yield put(actions.numerologyVerifyPurchaseSuccess(result.data));
  } catch (e) {
    yield put(actions.numerologyVerifyPurchaseFailure(e));
  }
}

function* verifyPaypalPurchase(action) {
  try {
    const result = yield call(AxiosPost, `/numerology/verify_paypal_purchase/`, { ...action.payload, ...getFbTrackingPayload() });
    yield put(actions.numerologyVerifyPaypalSuccess(result.data));
  } catch (e) {
    yield put(actions.numerologyVerifyPaypalFailure(e));
  }
}

function* fetchCompatibility(action) {
  try {
    const result = yield call(AxiosPost, `/numerology/get_compatibility/`, action.payload);
    yield put(actions.numerologyCompatibilitySuccess(result.data));
  } catch (e) {
    yield put(actions.numerologyCompatibilityError(e));
  }
}

function* setReadingLike(action) {
  try {
    yield call(AxiosPost, `/numerology/set_reading_like/`, action.payload);
    yield put(actions.numerologyLikeSuccess());
  } catch (e) {
    // silent fail for like
  }
}

function* fetchNumbers() {
  try {
    const result = yield call(AxiosCall, `/numerology/get_numbers/`);
    const { results } = result.data;
    yield put(actions.numerologyNumbersSuccess(results));
  } catch (e) {
    yield put(actions.numerologyNumbersError(e));
  }
}

export default function* numerologySaga() {
  yield all([
    takeLatest(actions.NUMEROLOGY_AVAILABILITY_REQUEST, fetchAvailability),
    takeLatest(actions.NUMEROLOGY_CALCULATE_REQUEST, calculate),
    takeLatest(actions.NUMEROLOGY_PREMIUM_REQUEST, fetchPremiumReading),
    takeLatest(actions.NUMEROLOGY_COMPATIBILITY_REQUEST, fetchCompatibility),
    takeLatest(actions.NUMEROLOGY_LIKE_REQUEST, setReadingLike),
    takeLatest(actions.NUMEROLOGY_NUMBERS_REQUEST, fetchNumbers),
    takeLatest(actions.CREATE_PENDING_NUMEROLOGY_REQUEST, createPendingNumerology),
    takeLatest(actions.CREATE_CONSULTA_NUMEROLOGY_REQUEST, createConsultaNumerology),
    takeLatest(actions.CREATE_BODA_NUMEROLOGY_REQUEST, createBodaNumerology),
    takeLatest(actions.NUMEROLOGY_CHECKOUT_REQUEST, createCheckout),
    takeLatest(actions.NUMEROLOGY_PAYPAL_ORDER_REQUEST, createPaypalOrder),
    takeLatest(actions.NUMEROLOGY_VERIFY_PURCHASE_REQUEST, verifyPurchase),
    takeLatest(actions.NUMEROLOGY_VERIFY_PAYPAL_REQUEST, verifyPaypalPurchase),
  ]);
}
